import Data from '../data/index';

export default function Reducer(state = {}, action) {
  switch (action.type) {
    case 'CHANGE_FONT':
      return Object.assign({}, state, {font: action.value});
  
    case 'CHANGE_PLATFORM':
      return Object.assign({}, state, {platform: action.value});

   
    case 'CHANGE_BACKGROUND':
      console.log('CHANGE_BACKGROUND', action.value);
      return Object.assign({}, state, {background: action.value});

    case 'CHANGE_PHRASE':
      console.log('CHANGE_PHRASE', action.value);
      return Object.assign({}, state, {phrase: action.value});

    case 'CHANGE_SIZE':
      console.log('CHANGE_SIZE', action.value);
      return Object.assign({}, state, {fontSize: action.value});

    case 'CHANGE_ALIGN':
      console.log('CHANGE_ALIGN', action.value);
      return Object.assign({}, state, {textAlign: action.value});
    
    case 'CHANGE_BOLD': 
      console.log('CHANGE_BOLD', action.value);
      return Object.assign({}, state, {isBold: action.value});

    case 'CHANGE_ITALIC': 
      console.log('CHANGE_ITALIC', action.value);
      return Object.assign({}, state, {isItalic: action.value});

    case 'CHANGE_COLOR': 
      console.log('CHANGE_COLOR', action.value);
      return Object.assign({}, state, {colorOverlay: action.value});


    case 'URL_GENERATE':
      var url ='';
      const urlPrefix = 'https://res.cloudinary.com/pennon-dev/image/upload';

      url += urlPrefix;

      const quality = 75;
      url += '/q_' + quality;

      var platform = Data.Platforms.filter((platform) => platform.id === state.platform)[0];
      var font = Data.Fonts.filter((font) => font.id === state.font)[0];
      var background = state.background;
      var fontSize = Data.Sizes.filter((size) => size.id === state.fontSize)[0];
      var lineHeight = (0 - Math.round(fontSize.size/4)).toString();
      console.log('lineHeight', lineHeight)
      var textAlign = Data.Align.filter((align) => align.id === state.textAlign)[0];
      var color = Data.Colors.filter((color) => color.id === state.colorOverlay)[0];

      //Image Dimensions
      url +='/w_'+platform.width+',h_'+platform.height;

      //Base Image
      url += ',c_fill';
      if (color.id === 'none') {
        url += '/e_colorize:30,co_rgb:000000';
      } else {
        url += '/e_brightness:-15/e_grayscale/e_contrast:70/e_colorize:60,co_rgb:'+(color.color.replace('#',''));
      }

      //Text Dimensions, Base Text, Blur
      url += '/e_blur:300,w_'+platform.textWidth+',c_fit,co_rgb:000000,l_text:'+encodeURIComponent(font.id)+'_'+fontSize.size;
      if (state.isBold) url += '_bold';
      if (state.isItalic) url += '_italic';
      url += '_text_align_'+textAlign.id;
      url += '_line_spacing_'+lineHeight;
      url += ':'+escape(encodeURIComponent(state.phrase));
      url += ',o_66';
      url += ',y_3';

      url += '/w_'+platform.textWidth+',c_fit,co_rgb:FFFFFF,l_text:'+encodeURIComponent(font.id)+'_'+fontSize.size+'_';
      if (state.isBold) url += '_bold';
      if (state.isItalic) url += '_italic';
      url += '_text_align_'+textAlign.id;
      url += '_line_spacing_'+lineHeight;
      url += ':'+escape(encodeURIComponent(state.phrase));
      // url += ',y_20';

      url += '/'+background+'.jpg';//urlSuffix;

      console.log('URL GENERATE', url);
      return Object.assign({}, state, {url: url});


    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/reducer.js